<template>
  <div class="exProduct">
    <div v-if="addUpdate === 1">
      <div class="title">
        产品中心
        <p></p>
      </div>
      <!-- 目录 -->
      <div class="catalog">
        <el-button class="addCatalogBtn" @click="saveCatalog">新增目录</el-button>
        <el-button
          type="text"
          style="float:right;margin-left: 21px;line-height: 1;color: #34aadf;"
          @click="deleteCustom"
        >删除</el-button>
        <el-button
          type="text"
          style="float:right;line-height: 1;color: #34aadf;"
          @click="updateCustom"
        >修改</el-button>
        <el-alert
          :title="'当前选择：' + currentOrg"
          type="info"
          :closable="false"
          style="margin: 18px 0 10px 0;"
        ></el-alert>
        <div class="trees">
          <div id="box">
            <el-tree
              ref="orgTree"
              node-key="id"
              :class="customStatus ? 'customClick' : ''"
              :data="orgTree"
              :highlight-current="true"
              :accordion="true"
              :props="{
              label:'name',
              'children':'children'
              }"
              @current-change="currentOrgChange"
            ></el-tree>
            <div class="box" v-infinite-scroll="load" infinite-scroll-disabled="disabled">
              <ul class="list">
                <li
                  v-for="(i,index) in list"
                  class="list-item"
                  :key="index"
                  :class="i.id === CustomActiveId ? 'activeBack' : ''"
                  @click="liCustomProductId(i.id,i)"
                >{{ i.name }}</li>
              </ul>
              <!-- <p v-if="loading" style="margin-top:10px;" class="loading">
                <span></span>
              </p>
              <p v-if="noMore" style="margin-top:10px;font-size:13px;color:#ccc">没有更多了</p>-->
            </div>
          </div>
        </div>
      </div>
      <!-- 表格 -->
      <div class="butTabs">
        <!-- <el-button class="tabBtn" :class="all === '5' ? 'btnFocus' : ''" @click="statusBtn('5')">全部</el-button>
        <el-button class="tabBtn" :class="all === '0' ? 'btnFocus' : ''" @click="statusBtn('0')">已推荐</el-button>
        <el-button class="tabBtn" :class="all === '1' ? 'btnFocus' : ''" @click="statusBtn('1')">已审批</el-button>-->
        <el-button class="addCatalogBtn" @click="saveProduct">新增产品</el-button>
        <el-table
          :header-cell-style="{background: '#f2f2f2',color: '#333333',fontSize: '14px'}"
          :row-style="{height: '50px'}"
          border
          :data="productList.slice( (pageIndex - 1) * pageSize, pageIndex * pageSize )"
        >
          <el-table-column header-align="center" align="center" width="68" label="封面">
            <template slot-scope="scope">
              <img :src="$getSrc(scope.row.image)" alt class="tabImg" />
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" width="88" label="标题" prop="title"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            width="145"
            label="最后修改时间"
            prop="updateDate"
          ></el-table-column>
          <el-table-column header-align="center" align="center" width="81" label="状态" prop="status"></el-table-column>
          <el-table-column header-align="center" align="center" width="226" label="操作">
            <template slot-scope="scope">
              <el-button type="text" class="caoz" @click="recommend">推荐</el-button>
              <el-button type="text" class="caoz" @click="see(scope.row.id)">查看</el-button>
              <el-button type="text" class="caoz" @click="update(scope.row.id)" v-if="scope.row.status === '- 待审核' ||scope.row.status === '- 未通过'">编辑</el-button>
              <el-button type="text" class="caoz" @click="deleteP(scope.row.id)" v-if="scope.row.status === '- 待审核' ||scope.row.status === '- 未通过'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="fenye">
        <el-pagination
          background
          @current-change="currentChangeHandle"
          :current-page="pageIndex"
          :page-size="pageSize"
          :total="infomationList.length"
          layout="slot"
        >
          <span style="color: #7a7a7a;font-size: 12px;margin-right: 15px;line-height: 36px;">
            共
            {{ totalIndex }}
            页
          </span>
          <el-button
            :disabled="firstPageBtnDisabled"
            class="first-pager"
            @click="toFirstPage"
          ><< &nbsp;首页</el-button>
        </el-pagination>
        <el-pagination
          background
          @current-change="currentChangeHandle"
          :current-page="pageIndex"
          :page-size="pageSize"
          :total="productList.length"
          layout="pager, next, slot, jumper "
        >
          <el-button
            :disabled="lastPageBtnDisabled"
            class="first-pager"
            @click="toLastPage"
          >末页 &nbsp;</el-button>
        </el-pagination>
      </div>
    </div>

    <add-or-update
      v-if="addUpdate === 2"
      @addUpdateStatus="addUpdateStatus"
      :productId="productId"
      @getProductList="getProductList"
      @productIdSetNull="productIdSetNull"
      :staticPro="staticPro"
    ></add-or-update>
    <product-info
      v-if="addUpdate === 3"
      @edit="saveProduct"
      @addUpdateStatus="addUpdateStatus"
      :productId="productId"
    ></product-info>

    <el-dialog
      :title=" CustomActiveId ? '修改目录' : '新增目录'"
      :visible.sync="dialogVisible"
      width="580px"
      :before-close="handleClose"
    >
      <el-input v-model="saveP" placeholder="请填写目录名称" class="catalogName"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="addProduct" v-if="!CustomActiveId">确认新增</el-button>
        <el-button type="primary" @click="updateProduct" v-else>确认修改</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="tui" width="580px" @beforeClose="tui = false">
      <div class="tuiContent">
        <p>如有产品欲推荐发布至展会首页“产品中心”请联系管理员</p>
        <p>010-82210085</p>
      </div>
      <span slot="footer" class="dialog-footer tuiFooter">
        <el-button type="primary" @click="tui = false">知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import addOrUpdate from "./add-or-update-product";
import productInfo from "./ProductInfo";
export default {
  components: {
    addOrUpdate,
    productInfo,
  },
  data() {
    return {
      customStatus: false,
      addUpdate: 1,
      tui: false,
      count: 0, //起始页数值为0
      loading: false,
      totalPages: "", //取后端返回内容的总页数
      list: [], //后端返回的数组

      saveP: "",
      productList: [],
      all: "5", // 选中全部 | 已推荐 | 已审批哪个按钮
      productId: "",
      CustomActiveId: "", // 自定义目录id
      customCatalogName: "", // 自定义目录name

      orgTree: [],
      currentOrg: "",
      key: "",
      currentOrgId: "",
      dialogVisible: false,
      infomationList: [],
      pageSize: 5, // 每页条数
      pageIndex: 1, // 当前页
      totalPage: 0, // 总条数
      firstPageBtnDisabled: true,
      lastPageBtnDisabled: false,
      totalIndex: 0,
      staticPro: [],
    };
  },
  computed: {
    noMore() {
      //当起始页数大于总页数时停止加载
      return this.count >= this.totalPages - 1;
    },
    disabled() {
      return this.loading || this.noMore;
    },
  },
  mounted() {
    this.getProductList();
    this.getStaticPro();
  },
  methods: {
    load() {
      //滑到底部时进行加载
      // this.loading = true;
      // setTimeout(() => {
      //   this.count += 1; //页数+1
      //   this.getMessage(); //调用接口，此时页数+1，查询下一页数据
      // }, 2000);
    },
    // getMessage() {
    //   let params = {
    //     pageNumber: this.count,
    //     pageSize: 10, //每页查询条数
    //   };
    //   this.$axios
    //     .post("https://接口", params)
    //     .then((res) => {
    //       this.list = this.list.concat(res.data.body.content); //因为每次后端返回的都是数组，所以这边把数组拼接到一起
    //       this.totalPages = res.data.body.totalPages;
    //       this.loading = false;
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },

    // 自定义目录click
    liCustomProductId(customId, custom) {
      this.customStatus = custom.type === "0" ? false : true;
      this.currentOrg = custom.name;
      this.customCatalogName = custom ? custom.name : "";
      this.CustomActiveId = customId;
      this.$http({
        url: "getAccConByAccIdAndTypeAndProduct",
        method: "post",
        params: {
          display: "5",
          productId: customId,
        },
      })
        .then(({ data }) => {
          let { code, accConType1List } = data;
          if (code === 0) {
            accConType1List.forEach((res) => {
              res.recommendTrue = res.display === "0" ? false : true;
              if (res.status === "1") {
                res.status = "- 已下线";
              } else if (res.status === "0") {
                res.status = "- 已发布";
              }else if (res.status === "3") {
				  res.status = "- 未通过";
			  }else {
                res.status = "- 待审核";
              }
            });
            this.productList = accConType1List;
            this.totalIndex = Math.ceil(
              this.productList.length / this.pageSize
            );
          }
        })
        .catch((err) => console.log(err));
    },

    // 编辑产品时的产品列表(productInfo)
    getStaticPro() {
      this.$http({
        url: "getProductList",
        method: "post",
      })
        .then((data) => {
          let { code, proParentList } = data.data;
          if (code === 0) {
            this.staticPro = proParentList;
          } else {
            this.$message.error("登录失效，请重新登录");
            this.$router.push("/login");
          }
        })
        .catch((err) => {
          this.$message.error("登录失效，请重新登录");
          this.$router.push("/login");
        });
    },

    // 所有产品
    getProductList() {
      this.$http({
        url: "getAccConByDisplay",
        method: "post",
        params: {
          type: "0",
        },
      })
        .then(({ data }) => {
          let { code, accConByAccIdAndType } = data;
          if (code === 0) {
            accConByAccIdAndType.forEach((res) => {
              res.recommendTrue = res.display === "0" ? false : true;
              if (res.status === "1") {
                res.status = "- 已下线";
              } else if (res.status === "0") {
                res.status = "- 已发布";
              } else if (res.status === "3") {
				  res.status = "- 未通过";
			  } else {
                res.status = "- 待审核";
              }
            });
            this.productList = accConByAccIdAndType;
            this.totalIndex = Math.ceil(
              this.productList.length / this.pageSize
            );
          } else {
            this.$message.error("登录失效，请重新登录");
            this.$router.push("/login");
          }
        })
        .catch((err) => {
          this.$message.error("登录失效，请重新登录");
          this.$router.push("/login");
        });
      this.$http({
        url: "productListByAccIdAndDisplay",
        method: "post",
      })
        .then(({ data }) => {
          let { code, staticProductList, accProByIdAndMySelfList } = data;
          if (code === 0) {
            this.orgTree = staticProductList;
            this.list = accProByIdAndMySelfList;
          } else {
            this.$message.error("登录失效，请重新登录");
            this.$router.push("/login");
          }
        })
        .catch((err) => {
          this.$message.error("登录失效，请重新登录");
          this.$router.push("/login");
        });
    },

    // 全部 | 已推荐 | 已审批
    statusBtn(num) {
      this.all = num;
      if (this.CustomActiveId) {
        this.liCustomProductId(this.CustomActiveId);
      } else {
        this.getProductList(num);
      }
    },

    // 推荐
    recommend() {
      this.tui = true;
    },
    // 编辑产品
    update(id) {
      this.addUpdate = 2;
      this.productId = id;
    },
    productIdSetNull() {
      this.productId = null;
    },

    // 删除产品
    deleteP(id) {
      this.$confirm("确认删除当前产品？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http({
          url: "deleteAccConInfoById",
          method: "post",
          params: {
            accConId: id,
          },
        })
          .then(({ data }) => {
            if (data.code === 0) {
              this.$message({
                message: `产品删除成功！`,
                type: "success",
                duration: 1000,
                onClose: () => {
                  this.getProductList();
                },
              });
            }
          })
          .catch((err) => console.log(err));
      });
    },
    // 查看产品
    see(id) {
      this.addUpdate = 3;
      this.productId = id;
    },

    // 新增目录按钮
    saveCatalog() {
      this.dialogVisible = true;
    },
    // 确认新增目录
    addProduct() {
      this.$http
        .post("saveProduct", {
          name: this.saveP,
        })
        .then((response) => {
          let { code, msg } = response.data;
          if (code === 0) {
            this.$message({
              message: "添加成功",
              type: "success",
              duration: 1500,
              onClose: () => {
                this.dialogVisible = false;
                this.getProductList();
              },
            });
          } else {
            this.$message.error(msg);
          }
        });
    },
    handleClose(done) {
      this.dialogVisible = false;
      this.CustomActiveId = null;
      this.saveP = "";
    },
    // 新增产品
    saveProduct() {
      this.addUpdate = 2;
      this.productIdSetNull();
    },
    // 修改目录
    updateCustom() {
      this.dialogVisible = true;
      this.saveP = this.customCatalogName;
    },
    updateProduct() {
      this.$http({
        url: "updateProductById",
        method: "post",
        data: this.$http.adornData({
          name: this.saveP,
          id: this.CustomActiveId,
        }),
      })
        .then(({ data }) => {
          let { code, msg } = data;
          if (code === 0) {
            this.$message({
              message: "目录修改成功",
              type: "success",
              duration: 1000,
              onClose: () => {
                this.dialogVisible = false;
                this.getProductList();
              },
            });
          } else {
            this.$message.error(msg);
          }
        })
        .catch((err) => console.log(err));
    },
    // 删除目录
    deleteCustom() {
      if (this.CustomActiveId) {
        this.$http({
          url: "deleteProductById",
          method: "post",
          params: {
            id: this.CustomActiveId,
          },
        })
          .then(({ data }) => {
            let { code, msg } = data;
            if (code === 0) {
              this.$message({
                message: "目录删除成功",
                type: "success",
                duration: 500,
                onClose: () => {
                  this.getProductList();
                },
              });
            } else {
              this.$message.error("固定目录不允许删除！");
            }
          })
          .catch((err) => console.log(err));
      } else {
        this.$message.warning("请选择要删除的自定义目录！");
      }
    },

    // 子组件调用
    addUpdateStatus() {
      this.addUpdate = 1;
    },

    // 当前选中
    currentOrgChange(data, node) {
      if (data.parentId !== 0) {
        this.liCustomProductId(data.id, data);
      }
      this.$refs.orgTree.setCheckedKeys([]);

      if (this.currentOrgId == data.id) {
        return false;
      }
      this.currentOrgId = data.id;
      // this.$refs.orgTree.setChecked(data,true, false);
      this.currentOrg =
        node.level === 1 ? node.data.name : node.parent.data.name;
    },

    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.firstPageBtnDisabled = val === 1 ? true : false;
      this.lastPageBtnDisabled = val === this.lastPageNum ? true : false;
    },
    // 首页
    toFirstPage() {
      this.pageIndex = 1;
      this.lastPageBtnDisabled = false;
      this.firstPageBtnDisabled = true;
    },
    // 尾页
    toLastPage() {
      this.pageIndex = this.lastPageNum;
      this.firstPageBtnDisabled = false;
      this.lastPageBtnDisabled = true;
    },
  },
};
</script>
<style lang="scss">
.exProduct {
  .customClick .el-tree-node.is-current > .el-tree-node__content {
    background-color: #ffffff !important;
  }

  .el-table th > .cell {
    padding: 8px;
  }
  .el-table .cell {
    padding: 0;
  }
  .tabImg {
    width: 40px;
    height: 40px;
  }
  .el-table th,
  .el-table td {
    padding: 5px;
  }

  // 树形控件当前选中项父级字体颜色
  .el-tree--highlight-current
    .el-tree-node.is-expanded
    > .el-tree-node__content {
    color: #143372;
    .el-tree-node__expand-icon {
      color: #143372;
    }
  }
  // 树形控件当前选中项背景颜色
  .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: #f2f2f2;
  }
  .el-table--border th,
  .el-table--border td {
    border-right: 1px solid #e5e5e5;
  }
  .el-alert__content {
    padding: 0;
  }
  .el-tree-node__content {
    overflow: hidden;
  }
  .el-dialog {
    height: 220px;
    margin-top: 33vh;
    border: 1px solid #e5e5e5;
    .el-dialog__header {
      height: 48px;
      padding: 0;
      line-height: 48px;
      text-indent: 31px;
      font-size: 18px;
      .el-dialog__title {
        color: #143372;
      }
      border-bottom: 1px solid #e5e5e5;
    }
    .el-dialog__body {
      height: 102px;
      padding: 0;
      .catalogName {
        width: 520px;
        height: 42px;
        margin: 30px 0 0 29px;
      }
      border-bottom: 1px solid #e5e5ee;
    }
    .el-dialog__footer {
      padding: 0;
      height: 66px;
      background-color: #fafafa;
      .el-button {
        line-height: 0;
      }
      .el-button--default {
        width: 70px;
        height: 34px;
        background-color: #e5e5e5;
        color: #333333;
        text-align: center;
        margin-top: 15px;
        &:hover {
          border-color: #e5e5e5;
        }
      }
      .el-button--primary {
        width: 96px;
        height: 34px;
        color: #ffffff;
        background-color: #143372;
        border-color: #143372;
        margin: 15px 30px 0 12px;
      }
    }
    .tuiContent {
      text-align: center;
      line-height: 30px;
      padding-top: 20px;
    }
    .tuiFooter {
      margin-right: 35%;
    }
  }
  .fenye {
    height: 32px;
    text-align: center;
    margin-top: 57px;
    margin-left: 32%;
    .el-pagination {
      width: 121px;
      float: left;
      .el-pager {
        height: 32px;
        li:not(.disabled).active {
          background-color: #2878ff;
          color: #ffffff;
        }
        .number:hover {
          color: #9ea4b9;
        }
      }
      .btn-next,
      .number {
        width: 32px;
        height: 32px;
        border: 1px solid #e6e6e6;
        border-radius: 5px;
        line-height: 32px;
        color: #9ea4b9;
        background-color: #ffffff;
      }
      .el-pagination__jump {
        height: 32px;
        line-height: 32px;
        margin-left: 15px;
      }
    }
    .first-pager {
      width: 74px;
      height: 32px;
      border: 1px solid #e6e6e6;
      border-radius: 5px;
      text-align: center;
      color: #9ea4b9;
      &:focus,
      &:hover {
        background-color: #ffffff;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.exProduct {
  .title {
    width: 100%;
    height: 66px;
    line-height: 66px;
    font-size: 18px;
    color: #143372;
    position: relative;
    border-bottom: 1px solid #e5e5e5;
    text-indent: 30px;
    margin-bottom: 18px;
    p {
      width: 70px;
      height: 2px;
      background-color: #143372;
      position: absolute;
      bottom: -1px;
      left: 30px;
    }
  }
  .catalog {
    width: 230px;
    float: left;
  }
  .trees {
    width: 228px;
    height: 367px;
    border: 1px solid #e5e5e5;
    .el-tree {
      width: 210px;
    }
  }
  .addCatalogBtn {
    width: 112px;
    height: 36px;
    font-size: 14px;
    color: #ffffff;
    background-color: #143372;
    line-height: 0;
    margin-bottom: 18px;
  }
  .butTabs {
    width: 610px;
    height: 468px;
    float: right;
    margin-right: 31px;
    .tabBtn {
      width: 84px;
      height: 34px;
      border: 1px solid #e5e5e5;
      color: #484848;
      margin-bottom: 18px;
      line-height: 0;

      &:hover {
        background-color: #ffffff;
      }
    }
    .caoz {
      font-size: 12px;
      color: #17a3dd;
    }
  }
  .btnFocus {
    border: 1px solid #143372 !important;
    color: #143372 !important;
    background-color: #ffffff;
  }
}

#box {
  width: 230px;
  height: 367px;
  position: absolute;
  overflow-y: auto;
}
.box {
  width: 100%;
  margin: 0 auto;
  height: 264px;
}
.list {
  padding: 0;
  font-size: 14px;
  height: 100%;
  margin-top: 30px;
}
.list-item {
  width: 100%;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  list-style: none;
  padding: 0 0 0 1rem;
  box-sizing: border-box;
  height: 26px;
  line-height: 26px;
  font-size: 12px;
  color: #333333;
  cursor: pointer;
  &:hover {
    background-color: #f2f2f2;
  }
}
.loading span {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid #409eff;
  border-left: transparent;
  // animation: zhuan 0.5s linear infinite;
  border-radius: 50%;
}
@keyframes zhuan {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
.activeBack {
  color: #143372;
  background-color: #f2f2f2;
}
</style>